import { useEffect } from 'react';
import { invalidateTripV1andV3Details } from 'obt-common';
import { useHistory, useParams } from 'react-router-dom';
import { EmbedEventTypes, useEmbedStore } from 'src/components/EmbedContext';
import useRetryPaymentService from '../xstate/useRetryPaymentService';
import { IRetryPaymentParams } from '../types';
import useGetTravelerProfileResponse from './useGetTravelerProfileResponse';

const useDoneHandler = (): void => {
  const retryPaymentService = useRetryPaymentService();

  const { tripId } = useParams<IRetryPaymentParams>();

  const traveler = useGetTravelerProfileResponse();

  const history = useHistory();
  const { reportEvent } = useEmbedStore();

  useEffect(() => {
    const doneHandler = (): void => {
      if (!retryPaymentService.state.matches('success')) {
        return;
      }

      const { retryPaymentRevalidateResponse } = retryPaymentService.state.context;

      if (traveler?.userOrgId) {
        invalidateTripV1andV3Details(tripId);
      }

      /**
       * Logging Event
       */
      reportEvent({
        type: EmbedEventTypes.PAYMENT_RETRIED,
        payload: {
          tripId,
          bookingId: retryPaymentRevalidateResponse.bookingId,
          spotnanaPnrId: retryPaymentService.state.context.pnrId,
        },
      });

      history.push({ pathname: `/trips/${tripId}` });
    };

    retryPaymentService.onDone(doneHandler);

    return (): void => {
      retryPaymentService.off(doneHandler);
    };
  }, [retryPaymentService, history, reportEvent, tripId, traveler]);
};

export default useDoneHandler;
